/**
 * Derive a stable slug value from a display label.
 * e.g. "Communication Services" → "communication-services", "Séminaire" → "seminaire"
 *
 * Accents are removed first so French labels keep readable slugs. The SQL equivalent in
 * supabase/migrations/20260211194545_app_configuration.sql only ran once on ASCII labels.
 */
export const toSlug = (label: string): string =>
  label
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
